module.exports = __webpack_public_path__ + "static/media/20-6.cb704cb5.mp3";